import { useCallback } from "react";
import { useTranslations } from "next-intl";
import { useToast } from "@/components/Toast/Toast";
import { formatGuestSeedToasts } from "@/lib/utils/guestSeedToasts";
import type { CreateEventResponse } from "@/lib/api/clients/EventClient";

/**
 * The ONE consumer seam for guest-seed outcome toasts (guest clone / CRM
 * import) — binds the toast provider + the shared `createEvent` i18n
 * namespace so the four call sites (create wizard, duplicate modal ×3) don't
 * each copy the translate-and-show loop.
 */
export function useGuestSeedToasts() {
  const t = useTranslations("createEvent");
  const { showToast } = useToast();

  return useCallback(
    (outcomes: Pick<
      CreateEventResponse,
      "crmImport" | "guestClone" | "droppedOnClone"
    >) => {
      for (const toast of formatGuestSeedToasts(outcomes)) {
        showToast(t(toast.key, toast.values), toast.type);
      }
    },
    [t, showToast],
  );
}
